import CircularLoader from "@/components/loading/LoadingComponent";
import { gql, useQuery } from "@apollo/client";
import { Navigate } from "react-router-dom";

const STREAM_TEAM_ACADEMY_FEATURE_FLAG_QUERY = gql`
    query StreamTeamAcademyFeatureFlag {
        featureFlags {
            streamTeamAcademyEnabled
        }
    }
`;

interface GuardProps {
    children: React.ReactNode;
}

export default function StreamTeamAcademyFeatureGuard({
    children,
}: GuardProps) {
    const { data, loading } = useQuery(STREAM_TEAM_ACADEMY_FEATURE_FLAG_QUERY, {
        fetchPolicy: "cache-and-network",
    });

    if (loading) {
        return <CircularLoader />;
    }

    const isAcademyEnabled = Boolean(
        data?.featureFlags?.streamTeamAcademyEnabled,
    );
    if (!isAcademyEnabled) {
        return <Navigate to="/team" replace />;
    }

    return <>{children}</>;
}
